import { css } from "styled-components"

export const quillContentCSS = css`
  margin: 0;
  padding: 0;
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  word-wrap: inherit;
  text-align: inherit;

  ul,
  ol {
    padding-left: 0;
  }

  pre {
    white-space: normal;
  }

  img {
    max-width: 100%;
  }

  code,
  pre {
    font-family: "Operator Mono", "SFMono-Regular", Consolas, "Liberation Mono",
      Menlo, Courier, monospace;
    tab-size: 2;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    background-color: #f6f8fa;
    border-radius: 6px;
    margin-bottom: 16px;
    padding: 5px;
  }

  a,
  p a,
  li a {
    text-decoration: underline;
  }

  .ql-blank::before {
    left: 0;
    right: 0;
  }

  pre.ql-syntax,
  pre.ql-syntax {
    background-color: #f6f8fa;
    color: inherit;
  }

  .katex {
    /* line-height: 1.8;
    font-size: 90%; */
    white-space: pre-wrap !important;
  }

  .BlockText ol li,
  .ql-editor ol li {
    counter-reset: listitem-1 listitem-2 listitem-3 listitem-4 listitem-5
      listitem-6 listitem-7 listitem-8 listitem-9;
    counter-increment: listitem-0;
  }

  .BlockText ol li:before,
  .ql-editor ol li:before {
    content: counter(listitem-0, decimal) ". ";
  }

  .BlockText ol li.ql-indent-1,
  .ql-editor ol li.ql-indent-1 {
    counter-increment: listitem-1;
  }

  .BlockText ol li.ql-indent-1:before,
  .ql-editor ol li.ql-indent-1:before {
    content: counter(listitem-1, lower-alpha) ". ";
  }

  .BlockText ol li.ql-indent-1,
  .ql-editor ol li.ql-indent-1 {
    counter-reset: listitem-2 listitem-3 listitem-4 listitem-5 listitem-6
      listitem-7 listitem-8 listitem-9;
  }

  .BlockText ol li.ql-indent-2,
  .ql-editor ol li.ql-indent-2 {
    counter-increment: listitem-2;
  }

  .BlockText ol li.ql-indent-2:before,
  .ql-editor ol li.ql-indent-2:before {
    content: counter(listitem-2, lower-roman) ". ";
  }

  .BlockText ol li.ql-indent-2,
  .ql-editor ol li.ql-indent-2 {
    counter-reset: listitem-3 listitem-4 listitem-5 listitem-6 listitem-7
      listitem-8 listitem-9;
  }

  .BlockText ol li.ql-indent-3,
  .ql-editor ol li.ql-indent-3 {
    counter-increment: listitem-3;
  }

  .BlockText ol li.ql-indent-3:before,
  .ql-editor ol li.ql-indent-3:before {
    content: counter(listitem-3, decimal) ". ";
  }

  .BlockText ol li.ql-indent-3,
  .ql-editor ol li.ql-indent-3 {
    counter-reset: listitem-4 listitem-5 listitem-6 listitem-7 listitem-8
      listitem-9;
  }

  .BlockText ol li.ql-indent-4,
  .ql-editor ol li.ql-indent-4 {
    counter-increment: listitem-4;
  }

  .BlockText ol li.ql-indent-4:before,
  .ql-editor ol li.ql-indent-4:before {
    content: counter(listitem-4, lower-alpha) ". ";
  }

  .BlockText ol li.ql-indent-4,
  .ql-editor ol li.ql-indent-4 {
    counter-reset: listitem-5 listitem-6 listitem-7 listitem-8 listitem-9;
  }

  .BlockText ol li.ql-indent-5,
  .ql-editor ol li.ql-indent-5 {
    counter-increment: listitem-5;
  }

  .BlockText ol li.ql-indent-5:before,
  .ql-editor ol li.ql-indent-5:before {
    content: counter(listitem-5, lower-roman) ". ";
  }

  .BlockText ol li.ql-indent-5,
  .ql-editor ol li.ql-indent-5 {
    counter-reset: listitem-6 listitem-7 listitem-8 listitem-9;
  }

  .BlockText ol li.ql-indent-6,
  .ql-editor ol li.ql-indent-6 {
    counter-increment: listitem-6;
  }

  .BlockText ol li.ql-indent-6:before,
  .ql-editor ol li.ql-indent-6:before {
    content: counter(listitem-6, decimal) ". ";
  }

  .BlockText ol li.ql-indent-6,
  .ql-editor ol li.ql-indent-6 {
    counter-reset: listitem-7 listitem-8 listitem-9;
  }

  .BlockText ol li.ql-indent-7,
  .ql-editor ol li.ql-indent-7 {
    counter-increment: listitem-7;
  }

  .BlockText ol li.ql-indent-7:before,
  .ql-editor ol li.ql-indent-7:before {
    content: counter(listitem-7, lower-alpha) ". ";
  }

  .BlockText ol li.ql-indent-7,
  .ql-editor ol li.ql-indent-7 {
    counter-reset: listitem-8 listitem-9;
  }

  .BlockText ol li.ql-indent-8,
  .ql-editor ol li.ql-indent-8 {
    counter-increment: listitem-8;
  }

  .BlockText ol li.ql-indent-8:before,
  .ql-editor ol li.ql-indent-8:before {
    content: counter(listitem-8, lower-roman) ". ";
  }

  .BlockText ol li.ql-indent-8,
  .ql-editor ol li.ql-indent-8 {
    counter-reset: listitem-9;
  }

  .BlockText ol li.ql-indent-9,
  .ql-editor ol li.ql-indent-9 {
    counter-increment: listitem-9;
  }

  .BlockText ol li.ql-indent-9:before,
  .ql-editor ol li.ql-indent-9:before {
    content: counter(listitem-9, decimal) ". ";
  }
`
